exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.textarea-limits[data-v-0d256e45] {\n    max-width:100%;\n    min-width:100%;\n    max-height:150px;\n}\n.tableFixHead[data-v-0d256e45]          { overflow-y: auto; max-height: 300px;\n}\n.tableFixHead thead th[data-v-0d256e45] { position: sticky; top: 0;\n}\ntable[data-v-0d256e45]  { border-collapse: collapse; width: 100%; border-radius: 3px;\n}\nth[data-v-0d256e45], td[data-v-0d256e45] { padding: 8px 16px;\n}\nth[data-v-0d256e45]     { background:#eee;\n}\n\n", ""]);

// exports
